export const CONFIG = {
    APP_NAME: 'Wishlist Compare Plus',
};
